
import { UsageRecord } from '../../types';
import { getProducts, setProducts } from '../product/core';
import { getUsageRecords, setUsageRecords } from './core';

/**
 * Update local product stock when adding a usage record
 */
export const updateLocalProductStock = (record: UsageRecord): void => {
  const products = getProducts();
  const productIndex = products.findIndex((p) => p.id === record.productId);
  
  if (productIndex !== -1) {
    const updatedProduct = {
      ...products[productIndex],
      currentStock: Math.max(0, products[productIndex].currentStock - record.quantity),
      updatedAt: new Date(),
    };
    
    products[productIndex] = updatedProduct;
    setProducts(products);
  }
};

/**
 * Add usage record to local storage
 */
export const addUsageRecordToLocalStorage = (record: UsageRecord): void => {
  const records = getUsageRecords();
  setUsageRecords([...records, record]);
  
  // Update the local product stock
  updateLocalProductStock(record);
};
